/* eslint-disable max-len */
import { Component } from '@angular/core';

@Component({
	selector: 'app-mtma-rules-access',
	templateUrl: './mtma-rules-access.component.html',
	animations: [],
})

export class MtmaRulesAccessComponent {
	constructor() { }
}

